import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto w-full px-6">
      <div className="p-6 rounded-md border bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-200">
        <h1 className="text-2xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">Last updated: July 17, 2025</p>

        <p className="mb-4 text-left">
          Welcome to BorsAI ('we,' 'our,' or 'us'). This Privacy Policy explains how we collect, use, and protect your information when you use our stock prediction and financial analysis service at borsai.net.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
    <p className="mb-2 text-left">We collect the following types of information when you interact with our platform:</p>

        <h3 className="text-lg font-semibold mt-4 mb-2">Personal Information</h3>
        <p className="mb-4 text-left">
          Name and Email Address: Collected only when you voluntarily provide them through our 'Contact Us' form to submit inquiries or feedback.
          We do not collect other personal information unless explicitly provided by you for specific purposes.
        </p>

        <h3 className="text-lg font-semibold mt-4 mb-2">Usage Data</h3>
        <p className="mb-4 text-left">
          Analytics Data: We use Google Analytics to collect anonymized data about platform usage for service improvement. This includes technical information such as anonymized IP addresses, browser type, and device information, as well as platform interaction data (e.g., page views and clicks).
          Note: We do not collect stock preferences, watchlists, or user-specific settings unless explicitly provided or configured by you.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">How We Use Your Information</h2>
        <ul className="list-disc list-outside mx-14 mb-4 text-left">
          <li>Personal Information (from Contact Form): To respond to your inquiries or feedback submitted via the 'Contact Us' form.</li>
          <li>Analytics Data: To monitor and improve the performance and functionality of our stock prediction and financial analysis service, focusing on stocks and cryptocurrencies , and to understand user behavior for enhancing the user experience.</li>
          <li>Platform Security: To detect and prevent fraudulent activity or security threats using technical data.</li>
        </ul>

        <p className="mb-4 text-left">
          We do not use your information for processing transactions or managing accounts unless explicitly part of a future service update, which will be reflected in this policy.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Data Protection</h2>
        <ul className="list-disc list-outside mx-14 mb-4 text-left">
          <li>Secure servers for hosting our platform.</li>
          <li>Encryption of sensitive data where applicable.</li>
          <li>Limiting access to personal data (e.g., contact form submissions) to authorized personnel only.</li>
        </ul>
        <p className="mb-4 text-left">
          However, no method of internet transmission or electronic storage is 100% secure. While we strive to protect your information, we cannot guarantee absolute security. Personal data received via email from the contact form is stored securely, but email transmission may not always be fully secure.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Cookies</h2>
        <ul className="list-disc list-outside mx-14 mb-4 text-left">
          <li><strong>Essential Cookies</strong>: Necessary for authentication, security, and basic platform functionality.</li>
          <li><strong>Analytics Cookies</strong>: Used by Google Analytics to understand how users interact with our website. These cookies are set only with your consent where required by law (e.g., via a cookie consent banner).</li>
        </ul>
        <p className="mb-4 text-left">You can manage your cookie preferences through your browser settings or our consent mechanism, if applicable.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Data Retention</h2>
        <ul className="list-disc list-outside mx-14 mb-4 text-left">
          <li><strong>Contact Form Data</strong>: Personal information submitted via the 'Contact Us' form (e.g., name and email) is retained only for as long as necessary to respond to your inquiry, typically no longer than 30 days, after which it is deleted from our email records unless required for legal purposes.</li>
          <li><strong>Analytics Data</strong>: Data collected via Google Analytics is retained according to Google’s data retention policies, and we configure settings to minimize storage duration where possible.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights Under GDPR</h2>
        <ul className="list-disc list-outside mx-14 mb-4 text-left">
          <li>Access your personal data we hold.</li>
          <li>Request correction or deletion of your data.</li>
          <li>Object to or restrict the processing of your data.</li>
          <li>Request to export your data in a structured, commonly used, and machine-readable format.</li>
          <li>Withdraw consent at any time, where processing is based on consent.</li>
        </ul>
        <p className="mb-4 text-left">To exercise these rights, please contact us using the details below. Since we collect minimal personal data, these rights primarily apply to information submitted via the contact form.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Changes to Privacy Policy</h2>
        <p className="mb-4 text-left">We may update this policy periodically to reflect changes in our practices or legal requirements. Significant changes will be notified through our platform or, where applicable, via email if we have your contact information for such purposes.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
        <p className="mb-1">Email: privacy@borsai.net</p>
        <p>Website: www.borsai.net</p>

        <p className="mt-6">By using our service, you acknowledge that you have read and understood this Privacy Policy.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
